import styled from '@app/styled';
import { spacing } from '@app/theme';

export const Container = styled.div`
    width: 100%;
    display: grid;
    gap: ${spacing(1)};
    grid-template-columns: 1fr max-content max-content;
    align-items: center;
`;
